<template>
  <div class="manage">
    <div class="treeList">
      <el-tree
          ref="deptTree"
          empty-text="暂无数据"
          :expand-on-click-node="true"
          :data="deptList"
          :props="defaultTreeProps"
          node-key="id"
          @node-click="handleNodeClick"
          highlight-current
      >
          <span class="treeNodeTxt" slot-scope="{ node }">
            <span>{{ node.label }}</span>
          </span>
      </el-tree>
    </div>
    <div class="content">
      <el-container>
        <el-header>
          <el-form :inline="true" :model="dataForm" label-width="100px">
            <el-row>
              <el-col :span="8">
                <el-form-item label="标题：">
                  <el-input v-model="dataForm.title" placeholder="请输入标题" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="来文字号：">
                  <el-input v-model="dataForm.documentNum" placeholder="请输入发文字号" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="审批状态：">
                  <el-select v-model="dataForm.approveStatus" placeholder="请选择审批状态">
                    <el-option value="0" label="待审批（未提交）">待审批（未提交）</el-option>
                    <el-option value="1" label="撤回">撤回</el-option>
                    <el-option value="2" label="待审批">待审批</el-option>
                    <el-option value="3" label="已通过">已通过</el-option>
                    <el-option value="4" label="已拒绝">已拒绝</el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item label="收文日期：">
                  <el-date-picker
                      v-model="dataForm.documentReceiveDate"
                      @change="documentReceiveDateChange"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="['00:00:00', '23:59:59']">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8" class="btnRight">
                <el-form-item class="btnList">
                  <el-button type="primary" @click="query()">查 询</el-button>
                  <el-button type="info" @click="reset()">重 置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-row v-if="dataForm.queryType == 1">
            <el-col :span="24">
              <div class="operatePanel">
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click="goToAddAndModiify(1)"
                >新建</el-button>
              </div>
            </el-col>
          </el-row>
        </el-header>
        <el-main ref="main">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="我的发文" name="first">
                <el-table
                        ref="dataTable"
                        :data="documentList"
                        highlight-current-row
                        size="mini"
                        height="100%"
                        border
                >
                  <el-table-column type="index" width="50"></el-table-column>
                  <el-table-column
                          prop="title"
                          label="标题"
                          :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                          prop="documentDeptName"
                          label="部门"
                          :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                          prop="documentNum"
                          label="来文字号"
                          :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                          prop="documentReceiveDate"
                          label="收文日期"
                          :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                          prop="approveStatusDisplayName"
                          label="审批状态"
                          :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column label="操作" header-align="center" align="center" width="180">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="goToDetails(scope.row)">详情</el-button>
                      <el-button v-if="scope.row.approveStatus == '0' || scope.row.approveStatus == 1" type="text" size="small" @click="handleSubmitClick(scope.row)">提交审批</el-button>
                      <el-button v-if="scope.row.approveStatus == '0' || scope.row.approveStatus == 1" type="text" size="small" @click="goToAddAndModiify(2,scope.row)">修改</el-button>
                      <el-button v-if="scope.row.approveStatus == '0' || scope.row.approveStatus == 1" type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
                      <el-button v-if="scope.row.approveStatus == 2" type="text" size="small" @click="handleWithdrawClick(scope.row)">撤回</el-button>
                      <el-button v-if="scope.row.approveStatus == 3" type="text" size="small" @click="goToPrint(scope.row)">打印</el-button>
                    </template>
                  </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="我的收文" name="second">
              <el-table
                      ref="dataTable"
                      :data="documentList"
                      highlight-current-row
                      size="mini"
                      height="100%"
                      border
              >
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column
                        prop="title"
                        label="标题"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentDeptName"
                        label="部门"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentNum"
                        label="来文字号"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="documentReceiveDate"
                        label="收文日期"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="approveStatusDisplayName"
                        label="审批状态"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="checkStatusDisplayName"
                        label="查阅状态"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column label="操作" header-align="center" align="center" width="180">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click=" scope.row.checkStatus== 1? goToDetails(scope.row): goToDetails(scope.row, 2)">详情</el-button>
                    <el-button type="text" size="small" @click="goToPrint(scope.row)">打印</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-main>
        <el-footer>
          <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="dataForm.pageIndex"
                  :page-sizes="[10, 20, 30, 50, 100]"
                  :page-size="dataForm.pageSize"
                  layout="total, prev, pager, next, sizes, jumper"
                  :total="total"
          ></el-pagination>
        </el-footer>
      </el-container>
    </div>

    <submit-review v-if="submitVisible" ref="submitReview" @refreshDataList="getReceiveList()"></submit-review>
  </div>
</template>

<script>
import {
  getOrgIdService, //根据用户id获取组织id
} from "@/services/sysSettingService";
import {
  deleteReceiveFileService,
  getExternalListService,
} from '@/services/documentServices'
import submitReview from "@/page/document/submit-review";
import {getDeptSubOwnListService} from "@/services/institutionService";
import {recallApproveProcessService} from "../../../services/engineering";
export default {
  name: "index",
  data(){
    return {
      activeName: 'first',
      dataForm: {
        queryType: 1, //1:我的发文，2:我的收文
        title: '',  //标题
        documentNum: '',  //发文字号
        documentDeptId: '',  //分类id
        approveStatus: '',  //审批状态
        documentReceiveDate: [],
        documentReceiveDateStart:'',
        documentReceiveDateEnd:'',
        pageIndex: 1,
        pageSize: 10,
      },

      deptList: [],
      defaultTreeProps: {
        id: "id",
        label: "name",
        children: "subDeptList"
      },
      documentList: [],
      total:0,

      submitVisible: false,
    }
  },
  components:{
    submitReview
  },
  methods:{
    onActive(menuCode) {
      // this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.getOrgIdList();
    },
    handleClick(tab, event){
      this.dataForm.pageIndex = 1;
      if(tab.index == 0){
        this.dataForm.queryType = 1;
        this.dataForm.documentDeptId = this.deptList[0].id
      }else {
        this.dataForm.queryType = 2;
        this.dataForm.documentDeptId = ''
      }
      this.getReceiveList();
    },
    getOrgIdList(){
      let params = {
        userId: sessionStorage.getItem('currentUserId')
      }
      getOrgIdService(params).then( res => {
        if(res.code == 10000000){
          res.data.deptVOList.map(item => {
            this.deptList = [];
            this.getdeptList(item.id)
          })
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    //查询部门列表
    getdeptList(deptId){
      let paramsData = {
        deptId: deptId
      }
      getDeptSubOwnListService(paramsData).then( res => {
        if(res.code == 10000000){
          // let subDeptList = this.deptList[0].subDeptList;
          // subDeptList.push(res.data)
          // this.deptList = [{
          //   id: '',
          //   name: '所属部门',
          //   subDeptList: subDeptList,
          // }]
          this.deptList.push(res.data);
          this.$nextTick(()=> {
            this.$refs['deptTree'].setCurrentKey(this.deptList[0].id)
            this.dataForm.documentDeptId = this.deptList[0].id
            this.getReceiveList();
          })
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    /* 菜单点击回调事件 */
    handleNodeClick(Node) {
      this.dataForm.documentDeptId = Node.id
    },
    //查询收文列表
    getReceiveList(){
      let paramsData = {
        ...this.dataForm
      }
      getExternalListService(paramsData).then( res => {
        if(res.code == 10000000){
          this.documentList = res.data;
          this.total = res.total;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    //查询
    query(){
      this.dataForm.pageIndex = 1;
      this.getReceiveList();
    },
    reset(){
      this.$refs['deptTree'].setCurrentKey(this.deptList[0].id)
      this.dataForm = {
        queryType: this.dataForm.queryType,
        title: '',  //标题
        documentNum: '',  //发文字号
        documentDeptId: this.deptList[0].id,  //部门id
        approveStatus: '',  //审批状态
        documentReceiveDate: [],
        documentReceiveDateStart:'',
        documentReceiveDateEnd:'',
        pageIndex: 1,
        pageSize: 10,
      }
      this.getReceiveList();
    },

    //时间选择
    documentReceiveDateChange(val){
      if(val){
        this.dataForm.documentReceiveDateStart = this.dataForm.documentReceiveDate[0];
        this.dataForm.documentReceiveDateEnd = this.dataForm.documentReceiveDate[1];
      }else{
        this.dataForm.documentReceiveDateStart = '';
        this.dataForm.documentReceiveDateEnd = '';
      }
    },
    // 去详情页
    goToDetails(item,type = 1){
      this.bus.$emit("navMenuChange", {
        routeId: "incomingManageDetails",
        routeParam: {
          id: item.id,
          type: type
        }
      });
    },
    //提交审批
    handleSubmitClick(item){
      if(item.createUserId != sessionStorage.getItem('currentUserId')){
        this.$message.error('非创建用户，不允许提交!');
        return
      }
      if(item.approveStatus == 3){
        this.$message.error('该收文已审批通过，不允许更新');
        return
      }
      if(item.approveStatus == 2){
        this.$message.error('该收文已开始审批，不允许更新');
        return
      }
      this.submitVisible = true
      this.$nextTick(() => {
        this.$refs.submitReview.titleIndex = 2;
        this.$refs.submitReview.classSelect = null;
        this.$refs.submitReview.approveList = [];
        this.$refs.submitReview.id = item.id;
        this.$refs.submitReview.title = item.title;
        this.$refs.submitReview.documentNum = item.documentNum;
        this.$refs.submitReview.init();
      })
    },
    // 删除列表
    deleteItem(item){
      if(item.approveStatus != '0' && item.approveStatus != '1' && item.approveStatus != '4'){
        this.$message.error('该收文已开始审批，不允许删除！');
        return
      }
      this.$confirm('此操作将永久删除该收文, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteSendItem(item);
      }).catch(() => {

      });
    },
    deleteSendItem(item){
      let paramsData = {
        systemFileExternalId: item.id,
      }
      deleteReceiveFileService(paramsData).then( res => {
        if(res.code == 10000000){
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getReceiveList();
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    // 撤回审批流
    handleWithdrawClick(item){
      this.$confirm("确定要撤回吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          itemId : item.id,
          type: 'OFFICIAL_DOCUMENT_EXTERNAL'
        }
        recallApproveProcessService(params).then( res => {
          if(res.code == 10000000){
            this.$message.success('撤回成功');
            this.query();
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      });
    },
    // 去新增修改页面
    goToAddAndModiify(documentType, item = null){
      if(documentType == 1){
        this.bus.$emit("navMenuChange", {
          routeId: "incomingManageAdd",
          routeParam: {
            id: item!= null? item.id: '',
            documentType: documentType
          }
        });
      }else{
        if(item.approveStatus == '0' || item.approveStatus == '1'|| item.approveStatus == '4'){
          this.bus.$emit("navMenuChange", {
            routeId: "incomingManageModiify",
            routeParam: {
              id: item!= null? item.id: '',
              documentType: documentType
            }
          });
        }else {
          this.$message.error('该收文仅允许待审核（未提交）、撤回和已拒绝状态的数据修改！');
          return
        }
      }
    },
    // 分页改变事件
    handleCurrentChange(page) {
      this.dataForm.pageIndex = page;
      this.getReceiveList();
    },
    // 分页显示数量改变事件
    handleSizeChange(rows) {
      this.dataForm.pageIndex = 1;
      this.dataForm.pageSize = rows;
      this.getReceiveList();
    },
    // 去打印页面
    goToPrint(item = null){
      if(item.approveStatus != 3){
        this.$message.error('该收文未通过审批，不允许打印');
        return
      }
      this.bus.$emit("navMenuChange", {
        routeId: "incomingManagePrint",
        routeParam: {
          id: item!= null? item.id: ''
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
/deep/.el-tabs__header{
  padding-right: 0 !important;
  .el-tabs__nav-wrap{
    padding-left: 30px;
  }
}
.manage{
  height: 100%;
  display: flex;
  justify-content: space-between;
  .treeList{
    width: 20%;
    height: 100%;
    overflow-y: auto;
    background-color: white;
    .treeItem{
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .content{
    width: 78%;
    background-color: white;
  }
}
.btnRight {
  display: flex;
  justify-content: flex-end;
  .btnList{
    text-align: right;
  }
  /deep/.el-form-item__content{
    height: auto;
  }
}
</style>
